import React, { useState, useEffect } from "react";
import LogoDark from "../../images/texpert-logo-dark.png";
import LogoLight from "../../images/texpert-logo.png";
import Menu from "../../layout/menu/Menu";
import MobileMenu from "../../layout/menu/MobileMenu";
import { Logo } from "../../components/logo/Logo";
import { Col, Container, Row } from "reactstrap";
import {
  Header,
  HeaderContent,
  HeaderMain,
  HeaderWrap,
} from "../../layout/header/Header";
import { Link } from "../../components/button/Button";
import {
  HeaderCaption,
  HeaderTitle,
} from "../../components/headerCaption/HeaderCaption";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "../../components/icon/Icon";

const BannerFour = (props) => {
  const [toggle, setToggle] = useState(false);
  const [offset, setOffset] = useState(0);
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    window.onscroll = () => {
      setOffset(window.pageYOffset);
    };
    window.scrollTo(0, 0);
    viewChange();
  }, []);

  // function to change the design view under 1200 px
  const viewChange = () => {
    if (window.innerWidth < 992) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  };

  window.addEventListener("resize", viewChange);
  return (
    <Header
      className={props.className && props.className}
      id={props.id && props.id}
    >
      <HeaderMain
        className={`header-main header-main-s1 is-sticky is-transparent on-dark ${
          offset > 0 ? "has-fixed" : ""
        }`}
      >
        <Container className="header-container">
          <HeaderWrap>
            <div className="header-logo">
              <Logo to="" dark={LogoLight} light={LogoDark} />
            </div>
            <div className="header-toggle" onClick={() => setToggle(!toggle)}>
              <button
                className={`menu-toggler ${toggle === true ? "active" : ""}`}
              >
                <em className="menu-on">
                  <Icon name="bars" className={["list", props.className ? props.className : null].join(" ")} iconType="fa" color="#42b490" />
                </em>
                <em className="menu-off">
                  <Icon name="x" className={["list", props.className ? props.className : null].join(" ")} iconType="fa" color="#42b490" />
                </em>                
              </button>
            </div>
            <nav
              className={`header-menu menu ${toggle === true ? "active" : ""} ${
                mobileView ? "mobile-menu" : ""
              }`}
            >
              {!mobileView ? (
                <Menu className="ml-lg-auto" data={props.categories} />
              ) : (
                <MobileMenu data={props.categories} />
              )}
            </nav>
            {toggle && window.innerWidth < 992 && (
              <div
                className="header-overlay"
                onClick={() => setToggle(!toggle)}
              ></div>
            )}
          </HeaderWrap>
        </Container>
      </HeaderMain>
      <HeaderContent className="py-6 is-dark mt-lg-n1 mt-n3">
        <Container>
          <Row className="row justify-content-center text-center g-gs">
            <Col md="12">
              <HeaderCaption>
                <HeaderTitle>Your DE&amp;I Strategy Maturity Report</HeaderTitle>
              </HeaderCaption>
            </Col>
          </Row>
        </Container>
      </HeaderContent>
    </Header>
  );
};

export default BannerFour;